// src/utils/relativeTime.js
//
// "2m ago" style formatting for liveness timestamps. Deliberately coarse: the
// exact second an agent was last seen is noise, and rounding keeps a polling UI
// from flickering between neighbouring values.

const MINUTE = 60;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

/**
 * @param {number|null} ts    epoch millis
 * @param {number}      now   epoch millis (injectable for tests)
 * @returns {string}          "just now" | "5m ago" | "3h ago" | "2d ago" | "unknown"
 */
export function relativeTime(ts, now = Date.now()) {
  if (typeof ts !== 'number' || !Number.isFinite(ts)) return 'unknown';

  const sec = Math.round((now - ts) / 1000);

  // A clock skewed slightly ahead of ours should read as "now", not "in -3s".
  if (sec < 45) return 'just now';
  if (sec < HOUR) return `${Math.round(sec / MINUTE)}m ago`;
  if (sec < DAY) return `${Math.round(sec / HOUR)}h ago`;
  return `${Math.round(sec / DAY)}d ago`;
}

/** Absolute local time, for the tooltip behind a relative label. */
export function absoluteTime(ts) {
  if (typeof ts !== 'number' || !Number.isFinite(ts)) return 'unknown';
  return new Date(ts).toLocaleString();
}

export default relativeTime;
